import { useState, useEffect, useContext, useRef } from 'react';
import { SideBarContext, LayoutContext } from '_context/LayoutContext';
import {MapContext} from '_context/MapContext';

export const InfoWindowHook = (props, gX, gY, width, height, who)=>{
    let gapX = gX
    let gapY = gY
    var windowWidth = width
    var windowHeight = height

    const [display, setDisplay] = useState('none')
    const [point, setPoint] = useState({x:0, y:0})
    const [transPoint, setTransPoint] = useState({x:0, y:0})
    const [opacity, setOpacity] = useState(1)
    const { toggle, sidebar } = useContext(SideBarContext);
    const { status } = useContext(LayoutContext);
    const marker = useRef();
    const [location, setLocation] = useState({x:0, y:0})
    const {ktMapIns} = useContext(MapContext);

    useEffect(() => {
        if(ktMapIns){
            ktMapIns.onEvent('bounds_changed', function (event, payload) {
                try{
                    setOpacity(0.5)
                    transCal()
                }catch(err){console.log(err)}
            });
            ktMapIns.onEvent('mousewheel', function (event, payload) {
                try{
                    setOpacity(0.5)
                    transCal()
                }catch(err){console.log(err)}
            }); //started
            ktMapIns.onEvent('idle', function (event, payload) {
                try{
                    let timer = setInterval(function() {
                        clearInterval(timer);
                        setOpacity(1)
                    },100);
                }catch(err){console.log(err)}
            });
        }
    }, [ktMapIns])

    useEffect(() => {
        if(props.signal){
            if(props.marker && props.marker._currentLayerPx){
                setPoint(props.marker._currentLayerPx)
                openingTranCal()
            }
            setDisplay('block')
        }
    }, [props.signal])

    useEffect(() => {
        if(props.marker){
            marker.current = props.marker
            openingTranCal()
        }else{
            setDisplay('none')
        }
    }, [props.marker])

    useEffect(() => {
        if(props.directClose){
            setDisplay('none')
        }
    }, [props.directClose]); 

    useEffect(() => {
        setDisplay('none')
    }, [props.immediateClose]); 

    useEffect(() => {
        if(display=='block' && point.x+getGapX()+transPoint.x < 400 && sidebar){
            let mgr = ktMapIns.getOverlayLayer().layerMgr
            let cord1 = mgr.getCoordFromLayerPx({x:450, y:0})
            let cord2 = mgr.getCoordFromLayerPx({x:point.x+getGapX()+transPoint.x, y:0})
            let center = ktMapIns.getCenter()
            center.x -= (cord1.x - cord2.x)
            ktMapIns.setCenter(center)
            transCal()
        }
    }, [sidebar]);

    useEffect(() => {
        setDisplay('none')
    }, [status])

    useEffect(() => {
        setLocation({x:point.x+getGapX()+transPoint.x, y:point.y-getGapY()+transPoint.y, display:display, opacity:opacity})
    }, [point, transPoint, display, opacity]); 

    const openingTranCal = ()=>{
        try{
            let marker = props.marker
            if(!marker.elements.upper_overlay_pane){
                marker = props.marker.parent
            }
            setDisplay('block')
            setPoint(marker._currentLayerPx)
            if(!marker.elements.upper_overlay_pane[0].parentElement){
                return
            }
            let centerMove = false
            let center = ktMapIns.getCenter()
            let mgr = ktMapIns.getOverlayLayer().layerMgr
            let pp = marker._currentLayerPx
            let trans = marker.elements.upper_overlay_pane[0].parentElement.parentElement.style.transform.split('(')[1].split(',')
            let tp = {x:pp.x+getGapX()+parseInt(trans[0]), y:pp.y-getGapY()+parseInt(trans[1])}
            if((tp.x + windowWidth) > (ktMapIns.elem.clientWidth - 62)){
                let cord1 = mgr.getCoordFromLayerPx({x:(ktMapIns.elem.clientWidth - 62), y:0})
                let cord2 = mgr.getCoordFromLayerPx({x:tp.x + windowWidth +10, y:0})
                center.x += (cord2.x - cord1.x)
                centerMove = true
            }
            if((tp.y) < 50){
                let cord1 = mgr.getCoordFromLayerPx({x:0, y:50})
                let cord2 = mgr.getCoordFromLayerPx({x:0, y:tp.y})
                center.y -= (cord1.y - cord2.y)
                centerMove = true
            }
            if(centerMove){
                ktMapIns.setCenter(center)
            }
            transCal()
        }catch(e){}
    }

    const transCal = ()=>{
        let maker = marker.current
        try{
            if(maker && maker.elements && maker.elements.upper_overlay_pane[0].parentElement){
                setPoint(maker._currentLayerPx)
                let trans = maker.elements.upper_overlay_pane[0].parentElement.parentElement.style.transform.split('(')[1].split(',')
                setTransPoint({x:parseInt(trans[0]), y:parseInt(trans[1])})
                // let checkX = parseInt(lyBox.current.style.left)
                // let checkY = parseInt(lyBox.current.style.top)
                // if(checkX<0 || checkX>ktMapIns.elem.clientWidt/2 || checkY<0 || checkY>ktMapIns.elem.clientHeight/2){
                //     setDisplay('none');
                //     props.close()
                // }else{
                //     setDisplay('block');
                // }
            }
        }catch(e){}
    }

    const getGapX = ()=>{
        if(marker.current && marker.current.gapX){
            return marker.current.gapX
        }else{
            return gapX
        }
    }

    const getGapY = ()=>{
        if(marker.current && marker.current.gapY){
            return marker.current.gapY
        }else{
            return gapY
        }
    }

    return {setDisplay, location}
}